var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "box view-nav-bar" }, [
      _c("div", { staticClass: "d-flex align-items-center w-100" }, [
        _c(
          "div",
          { staticClass: "flex-grow-1" },
          [
            _c(
              "router-link",
              { staticClass: "mr-3", attrs: { to: "/history/" + _vm.movixId } },
              [
                _c("icon", { attrs: { name: "chevron-left" } }),
                _vm._v(" Back\n                "),
              ],
              1
            ),
            _vm._v(" "),
            _c("strong", [_vm._v(_vm._s(_vm.movieTitle))]),
            _vm._v(" "),
            _c("span", { staticClass: "text-muted ml-2" }, [
              _vm._v("— Admissions per month"),
            ]),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [_vm._v("Loading…")]
          ),
        ])
      : !_vm.rows.length
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [_vm._v("No admissions data found.")]
          ),
        ])
      : _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "box-content" }, [
            _c("table", { staticClass: "shx-table w-100 mt-2" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.rows, function (row) {
                  return _c("tr", { key: row.month }, [
                    _c("td", [_vm._v(_vm._s(row.month))]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(_vm.formatInt(row.admissions))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "btn btn-sm btn-outline-secondary mr-2",
                            attrs: {
                              to:
                                "/history/" +
                                _vm.movixId +
                                "/month/" +
                                row.month +
                                "/day",
                            },
                          },
                          [
                            _vm._v(
                              "\n                                Per Day\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass: "btn btn-sm btn-outline-secondary",
                            attrs: {
                              to:
                                "/history/" +
                                _vm.movixId +
                                "/month/" +
                                row.month +
                                "/site",
                            },
                          },
                          [
                            _vm._v(
                              "\n                                Per Cinema\n                            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("tfoot", [
                _c("tr", [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.formatInt(_vm.totalAdmissions))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td"),
                ]),
              ]),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "shx-th-120" }, [_vm._v("Month")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-120 text-right" }, [
          _vm._v("Admissions"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-200" }, [_vm._v("Drill down")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Total")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }